<template>
	<tr class="hover:bg-gray-300 cursor-pointer" @click="redirectToTarget">
		<td class="px-6 py-4 whitespace-no-wrap w-128">
			<div class="flex items-center">
				<div class="mr-4 w-8 flex justify-center">
					<font-awesome-icon :icon="['fas', 'gavel']" size="2x" />
				</div>

				<div class="ml-4 text-left">
					<div class="text-md leading-5 font-medium text-gray-900 font-bold">
						{{ getName }}
					</div>
					<div class="text-md leading-5 text-gray-500">
						{{ getGroupName }}
					</div>
				</div>
			</div>
		</td>

		<td class="px-6 py-4 text-left whitespace-no-wrap">
			<div class="text-md leading-5 text-gray-900">{{ getOwnerName }}</div>
		</td>

		<td class="px-6 py-4 whitespace-no-wrap text-right text-lg font-medium">
			<div class="flex space-x-4 items-center justify-end">
				<font-awesome-icon :icon="['fas', 'chevron-right']" class="cursor-pointer" />
			</div>
		</td>
	</tr>
</template>

<script>
import { concatArray, getStringFromDate, getTimeFromDate } from '@/plugins/Utils';

export default {
	name: 'PremiumLawyerOfficeRow',
	props: {
		value: {
			type: Object,
			required: true,
		},
	},
	methods: {
		redirectToTarget() {
			this.$router.push({
				name: 'PremiumLawyerOfficeProfile',
				params: {
					id: (this.value.company_id || this.value.id).toString(),
					backlink: this.$route.path,
				},
			});
		},
	},
	computed: {
		getName() {
			return this.value.name ? this.value.name : `${this.value.ownerFirstname} ${this.value.ownerLastname}`;
		},
		getGroupName() {
			return this.value?.usergroup?.name;
		},
		getAuthorName() {
			return concatArray([this.value.created_by?.person?.firstName, this.value.created_by?.person?.lastName]);
		},
		getAuthorLevel() {
			return this.value.created_by?.usergroup?.name;
		},
		getOwnerName() {
			return concatArray([this.value.ownerFirstname, this.value.ownerLastname]);
		},
		getDate() {
			return new Date(this.value.created_at * 1000);
		},
		getDateString() {
			return getStringFromDate(this.getDate);
		},
		getTimeString() {
			return getTimeFromDate(this.getDate);
		},
	},
};
</script>
